





























































import "./tracking-filter.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "tracking-filter",
  props: {
    showValueFormatOptions: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      showFilterPoptip: false,
      valueFormat: "both",
    };
  },
  computed: {
    ...mapState("review", ["loading", "currentReview", "currentReviewTrackingMembers"]),
    targetUserFilter: {
      get() {
        return (this as any).$store.state.review.targetUserFilter;
      },
      set(newValue) {
        (this as any).$store.dispatch("review/setTargetUserFilter", newValue);
        (this as any).$emit("filter", {});
      },
    },
    assessmentFilter: {
      get() {
        return (this as any).$store.state.review.assessmentFilter;
      },
      set(newValue) {
        (this as any).$store.dispatch("review/setAssessmentFilter", newValue);
        (this as any).$emit("filter", {});
      },
    },
  },
  watch: {
    valueFormat(newValue) {
      (this as any).$emit("value-format-changed", newValue);
    },
  },
  methods: {
    handleRefreshClick() {
      let review = (this as any).currentReview;
      if (review) {
        this.$store.dispatch("review/get", { id: review.id });
      }
    },
  },
});
